import { SolinkLogo } from '@solinkcorp/solink-components';
import AnalyticsLogger from 'models/AnalyticsLogger';
import React, { useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { AuthStore } from 'stores/AuthStore';
import PreferenceStore from 'stores/PreferenceStore';
import { shouldShowNavTab } from '../shouldShowNavTab';
import NavTab, { type NavTabDescriptor } from './NavTab';

import './DesktopNav.sass';

export interface DesktopNavProps {
  tabs: NavTabDescriptor[];
}

const DesktopNav: React.FC<DesktopNavProps> = ({ tabs }) => {
  const showExperimentalFeatures = PreferenceStore.shouldShowExperimentalFeatures();
  const isTestUser = AuthStore.isTestUser();

  const visibleTabs = useMemo(
    () => tabs.filter((tab) => shouldShowNavTab(tab, showExperimentalFeatures, isTestUser)),
    [tabs, showExperimentalFeatures, isTestUser],
  );

  const handleSelectActiveIcon = useCallback((tab: NavTabDescriptor) => {
    AnalyticsLogger.selectNavigationTab({ tab: tab.page });
  }, []);

  return (
    <nav className="desktop-nav">
      <div className="company-logo" data-testid="desk-nav-company-logo">
        <Link to={'/'}>
          <SolinkLogo />
        </Link>
      </div>

      <ul>
        {visibleTabs.map((tab) => (
          <NavTab key={tab.page} tab={tab} onSelected={handleSelectActiveIcon} />
        ))}
      </ul>
    </nav>
  );
};

export default DesktopNav;
